import { Injectable } from '@angular/core';
import * as rudderAnalytics from 'rudder-sdk-js';
import { UserTraits } from './user-tracking.model';

type RudderAnalyticsApiOptions = Partial<{
  traits: Partial<UserTraits>;
  integrations: unknown;
  anonymousId: string;
  originalTimestamp: Date | string;
  [key: string]: unknown;
}>;

@Injectable()
export class RudderAnalyticsService {
  /** https://www.rudderstack.com/docs/sources/event-streams/sdks/rudderstack-javascript-sdk/quick-start-guide/#using-npm */
  load(cfg: { writeKey: string; dataplaneUrl: string; configUrl?: string }): void {
    rudderAnalytics.load(cfg.writeKey, cfg.dataplaneUrl, {
      configUrl: cfg.configUrl,
    });
  }

  identify(userId: string, traits: Partial<UserTraits>): Promise<void> {
    return new Promise((resolve) => rudderAnalytics.identify(userId, traits as rudderAnalytics.apiObject, {}, resolve));
  }

  page(name: string, properties: Record<string, unknown>, apiOpt?: RudderAnalyticsApiOptions): Promise<void> {
    return new Promise((resolve) =>
      rudderAnalytics.page(
        name,
        properties as rudderAnalytics.apiObject,
        apiOpt as rudderAnalytics.apiOptions,
        resolve,
      ),
    );
  }

  track(event: string, properties: Record<string, unknown>, apiOpt?: RudderAnalyticsApiOptions): Promise<void> {
    return new Promise((resolve) =>
      rudderAnalytics.track(
        event,
        properties as rudderAnalytics.apiObject,
        apiOpt as rudderAnalytics.apiOptions,
        resolve,
      ),
    );
  }
}
